import { createSlice } from '@reduxjs/toolkit';
import { meApi } from '~/api/me-api';

interface ApiUser {
  id?: string;
}

// Define the slice state
interface ApiUserState {
  user: ApiUser | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ApiUserState = {
  user: null,
  status: 'idle',
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch authenticated user
      .addMatcher(meApi.endpoints.getMe.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(meApi.endpoints.getMe.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.response.user;
      })
      .addMatcher(meApi.endpoints.getMe.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to fetch ApiUser from Session';
      })

      // Updating a authenticated user
      .addMatcher(meApi.endpoints.updateMe.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(meApi.endpoints.updateMe.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.user?.id === action.payload.id) {
          state.user = action.payload;
        }
      })
      .addMatcher(meApi.endpoints.updateMe.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to update ApiUser';
      });
  },
});

export default userSlice.reducer;
